import React, { useState, useContext, useEffect } from "react";
import { Text } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/modals/ModalSelectStoreAndSection";
import FormProduct from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/products/FormProduct";
import { GlobalContext } from "../../../../../../contexts/GlobalContext";
import { useLocation, useHistory } from "react-router-dom";
import { getAttributesByProduct, publishVariant } from "../../../../../../hooks/api/mercadoLibre";
import { Button } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/filters/FiltersStyles";
import ListOfProductsToSetParams from '../../../../../../assets/css/components/admin/marketplace-to-marketplace/products/ListOfProductsToSetParams'

export default function SetParamProdToPostVariant() {
  const { state } = useLocation();
  const history = useHistory();
  const { productData } = state || {};
  const globalContext = useContext(GlobalContext);
  const [formData, setFormData] = useState({});
  const [categoryAttr, setCategoryAttr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [publishLoading, setPublishLoading] = useState(false);

  /**
   * Obtiene el valor de un campo del formulario
   * @param {string} field - Nombre del campo
   * @returns {string} Valor del campo
   */
  const getValue = (field) => {
    return formData[field] !== undefined ? formData[field] : (productData?.[field] || '');
  };

  /**
   * Actualiza un campo del formulario
   * @param {string} field - Campo a actualizar
   * @param {*} value - Nuevo valor
   */
  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const updateField = (field) => (value) => {
    updateFormData(field, value);
  };
  
  /**
   * Maneja la publicación de la variante
   */
  const handlePublishVariant = async () => {
    try {
      setPublishLoading(true);
      const entId = globalContext.currentEnterpriseId;
      const variantId = productData.variantId;
      
      const dataToSend = {
        ...formData,
        price: formData.price || productData.price || '',
        title: formData.title || productData.title || '',
        customAttributes: formData.customAttributes || [],
        stock: productData.stock || 0
      };
      
      // Iniciar el proceso de publicación en segundo plano
      publishVariant(entId, variantId, dataToSend);
      
      // Mostrar mensaje de que el proceso está en segundo plano
      globalContext.showModalWithMsg("✅ Tu variante se está publicando en segundo plano...");
      
      // Regresar a la página anterior automáticamente
      setTimeout(() => {
        history.goBack();
      }, 2000);
      
    } catch (error) {
      console.error("Error al iniciar la publicación:", error);
      globalContext.showModalWithMsg("❌ Error al iniciar el proceso de publicación. Por favor, inténtalo de nuevo.");
    } finally {
      setPublishLoading(false);
    }
  };

  /**
   * Obtiene los atributos de la variante desde la API
   */
  const getAttributesVariants = async () => {
    try {
      setLoading(true);
      const entId = await globalContext.currentEnterpriseId;
      const variantId = productData.variantId;

      const response = await getAttributesByProduct(entId, variantId);
      const attributes = response.data.data.variationAttributes;
      
      setCategoryAttr([...attributes]);
      
    } catch (error) {
      setCategoryAttr([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (productData?.variantId) {
      getAttributesVariants();
    }
  }, [productData?.variantId]);

  useEffect(() => {
    if (productData) {
      setFormData(prev => ({
        ...prev,
        title: productData.title || '',
        price: productData.price || '',
      }));
    }
  }, [productData]);


  /**
   * Renderiza un campo dinamico basado en sus atributos
   * @param {Object} attribute - Atributo a renderizar
   */
  const renderSmartField = (attribute, index) => {
    const { id, name, valueType, validValues, values, value_type } = attribute;
    
    const handleFieldChange = (value) => {
      const customAttrs = formData.customAttributes || [];
      const attrIndex = customAttrs.findIndex(attr => attr.id === id);
      
      if (attrIndex > -1) {
        customAttrs[attrIndex].value_name = value;
      } else {
        customAttrs.push({ id: id, value_name: value });
      }
      
      updateFormData('customAttributes', [...customAttrs]);
    };

    const currentValue = formData.customAttributes?.find(attr => attr.id === id)?.value_name || '';
    const fieldType = valueType || value_type || 'string';
    
    // Renderizado condicional basado en el tipo de campo
    if (validValues && validValues.length > 0) {
      return (
        <FormProduct.ContInputAndLabel w='340px' key={`${id}-${index}`}>
          <Text size='12pt' fw='500'>{name}</Text>
          <FormProduct.Select
            value={currentValue}
            onChange={(e) => handleFieldChange(e.target.value)}
          >
            <option value="">Seleccionar {name.toLowerCase()}</option>
            {validValues.map((option) => (
              <option key={option.id} value={option.name}>
                {option.name}
              </option>
            ))}
          </FormProduct.Select>
        </FormProduct.ContInputAndLabel>
      );
    }

    if (values && values.length > 1) {
      return (
        <FormProduct.ContInputAndLabel w='340px' key={`${id}-${index}`}>
          <Text size='12pt' fw='500'>{name}</Text>
          <FormProduct.Select
            value={currentValue}
            onChange={(e) => handleFieldChange(e.target.value)}
          >
            <option value="">Seleccionar {name.toLowerCase()}</option>
            {values.map((value, valueIndex) => (
              <option key={valueIndex} value={value}>
                {value}
              </option>
            ))}
          </FormProduct.Select>
        </FormProduct.ContInputAndLabel>
      );
    }
    
    if (fieldType === 'number') {
      return (
        <FormProduct.ContInputAndLabel w='340px' key={`${id}-${index}`}>
          <Text size='12pt' fw='500'>{name}</Text>
          <FormProduct.Input
            type="number"
            placeholder={name}
            value={currentValue}
            onChange={(e) => handleFieldChange(e.target.value)}
          />
        </FormProduct.ContInputAndLabel>
      );
    }
    
    if (fieldType === 'boolean') {
      return (
        <FormProduct.ContInputAndLabel w='340px' key={`${id}-${index}`}>
          <Text size='12pt' fw='500'>{name}</Text>
          <FormProduct.Select
            value={currentValue}
            onChange={(e) => handleFieldChange(e.target.value)}
          >
            <option value="">Seleccionar</option>
            <option value="true">Sí</option>
            <option value="false">No</option>
          </FormProduct.Select>
        </FormProduct.ContInputAndLabel>
      );
    }
    
    // Campo de texto por defecto
    return (
      <FormProduct.ContInputAndLabel w='340px' key={`${id}-${index}`}>
        <Text size='12pt' fw='500'>{name}</Text>
        <FormProduct.Input
          type="text"
          placeholder={name}
          value={currentValue}
          onChange={(e) => handleFieldChange(e.target.value)}
        />
      </FormProduct.ContInputAndLabel>
    );
  };

  // Renderizado del componente
  return (
    <div style={{ width: "100%", height: "auto" }}>
      {/* Botón de retorno */}
      <div style={{ width: "100%", padding: "10px 0", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
        <Button 
          onClick={() => history.goBack()}
          style={{ 
            backgroundColor: "#6c757d",
            border: "none",
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "500",
            marginRight: "10px"
          }}
        >
          ← Regresar
        </Button>
      </div>
      
      {/* Vista previa del producto */}
      <ListOfProductsToSetParams.ContListProd>
        <ListOfProductsToSetParams.ListProduts>
          {
            <ListOfProductsToSetParams.ItemsListProduts
              key={productData._id}
              active={true}
              url={productData.thumbnail}
              load={false}
            >
            </ListOfProductsToSetParams.ItemsListProduts>
          }
        </ListOfProductsToSetParams.ListProduts>
      </ListOfProductsToSetParams.ContListProd>

      {/* Botón de publicación */}
      <div style={{ marginBottom: "20px", paddingTop: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Button 
          onClick={handlePublishVariant}
          disabled={publishLoading}
          style={{ 
            backgroundColor: publishLoading ? "#6c757d" : "#28a745",
            border: "none",
            padding: "12px 24px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: publishLoading ? "not-allowed" : "pointer"
          }}
        >
          {publishLoading ? "Publicando..." : "Publicar Variante"}
        </Button>
      </div>

      {/* Formulario principal */}
      {productData && (
        <FormProduct.ContForms>
          <FormProduct.Contform>
            <FormProduct.HeaderContForm>
              <Text size='13pt' fw='500' cl='#FFFFFF'>
                Llene los parametros para la variante a publicar
              </Text>
            </FormProduct.HeaderContForm>
            <FormProduct.BodyContForm>
              {/* Campo de título */}
              <FormProduct.ContInputAndLabel mr='5px'>
                <Text size='12pt' fw='500'>Titulo <sup>*</sup></Text>
                <FormProduct.Input
                  placeholder='Titulo de la Publicacion'
                  value={getValue('title')}
                  onChange={(e) => updateField('title')(e.target.value)}
                  maxLength={60}
                />
              </FormProduct.ContInputAndLabel>

              {/* Campo de precio */}
              <FormProduct.ContInputAndLabel w='340px'>
                <Text size='12pt' fw='500'>Precio <sup>*</sup></Text>
                <FormProduct.Input
                  type="number"
                  step="0.01"
                  placeholder="Precio de la variante"
                  value={getValue('price')}
                  onChange={(e) => updateField('price')(parseFloat(e.target.value) || 0)}
                />
              </FormProduct.ContInputAndLabel>

              {/* Estados de carga y mensajes */}
              {loading && (
                <Text size='12pt' fw='400' style={{ width: '100%', margin: '10px 0', color: '#0066cc' }}>
                  Cargando atributos...
                </Text>
              )}

              {!loading && categoryAttr === null && (
                <Text size='12pt' fw='400' style={{ width: '100%', margin: '10px 0', color: '#666' }}>
                  No se han cargado atributos
                </Text>
              )}

              {!loading && categoryAttr && categoryAttr.length === 0 && (
                <Text size='12pt' fw='400' style={{ width: '100%', margin: '10px 0', color: '#666' }}>
                  No hay atributos disponibles
                </Text>
              )}

              {/* Renderizado de atributos dinámicos */}
              {!loading && categoryAttr && categoryAttr.length > 0 && (
                <>
                  <Text size='13pt' fw='600' style={{ margin: '20px 0 10px 0', paddingTop: 20, color: '#333', width: '100%', display: 'block' }}>
                    Atributos de la Variante ({categoryAttr.length})
                  </Text>
                  {categoryAttr.map((attribute, index) => renderSmartField(attribute, index))}
                </>
              )}
            </FormProduct.BodyContForm>
          </FormProduct.Contform>
        </FormProduct.ContForms>
      )}
    </div>
  );
}
